import { useState } from "react";
import { useLocation } from "react-router-dom";
import { getAuth, signInWithCredential, PhoneAuthProvider } from "@firebase/auth";
import {
  Button,
  FormControl,
  FormErrorMessage,
  Heading,
  Icon,
  Input,
  InputGroup,
  InputLeftElement,
  Stack,
  Text,
  useToast,
} from "@chakra-ui/react";
import { BiCheck } from "react-icons/bi";
import { MdOutlineLock } from "react-icons/md";
import { messages } from "consts";
import * as yup from "yup";

export const SignInPhoneNumberValidate = () => {
  const location = useLocation();
  const { phoneNumber, verificationId } = location.state;
  const [formData, setFormData] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [loadingSignIn, setLoadingSignIn] = useState(false);
  const toast = useToast();

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      const schema = yup.object().shape({
        verificationCode: yup.string().required(messages.error.required),
      });
      await schema.validate(formData);
      handleSignIn(formData);
      setFormErrors({});
    } catch (error) {
      setFormErrors({ [error.path]: error.errors });
    }
  };

  const handleSignIn = async ({ verificationCode }) => {
    try {
      setLoadingSignIn(true);
      const auth = getAuth();
      const credential = PhoneAuthProvider.credential(verificationId, verificationCode);
      await signInWithCredential(auth, credential);
    } catch (error) {
      let description = messages.error.signInVerificationCode;
      if (error.code === "auth/user-disabled") description = messages.error.disabledUser;
      toast({ description, status: "error", duration: 5000, isClosable: true });
    } finally {
      setLoadingSignIn(false);
    }
  };

  return (
    <>
      <Heading marginBottom="0.5rem">Código de verificação</Heading>
      <Text fontSize="sm" marginBottom="1.5rem">
        Por favor, informe o código de verificação enviado para o número <strong>{phoneNumber}</strong>.
      </Text>
      <form onSubmit={handleSubmit}>
        <Stack spacing={4} marginBottom="1rem">
          <FormControl isRequired={true} isInvalid={formErrors.verificationCode}>
            <InputGroup>
              <InputLeftElement>
                <Icon as={MdOutlineLock} />
              </InputLeftElement>
              <Input
                type="password"
                placeholder="Informe o código de verificação"
                value={formData.verificationCode ?? ""}
                onChange={({ target }) => setFormData((state) => ({ ...state, verificationCode: target.value }))}
                autoFocus={true}
              />
            </InputGroup>
            <FormErrorMessage>{formErrors.verificationCode}</FormErrorMessage>
          </FormControl>
        </Stack>
        <Stack marginBottom="1rem">
          <Button type="submit" rightIcon={<Icon as={BiCheck} />} isLoading={loadingSignIn} colorScheme="main">
            Confirmar
          </Button>
        </Stack>
      </form>
    </>
  );
};
